<template>
  <div>
    <template v-for="(item,index) in list">
      <img v-if="$route.params.id == item.id" class="wiki-details-header-section" :alt="item.product_name" v-lazy="require('../assets/img/resources/uploads/' + item.img)" />
      <div v-if="$route.params.id == item.id" class="pest-intro-section">
        <div class="pest-intro-wrapper">
          <h1 class="pest-intro-title semibold white f24 blue-1 mb20">
            <router-link v-show="equipment == 'pc'" :to="{path: (product.product_name != null?'/service/' + product.product_name: '/')}">
              {{item.product_name}}
            </router-link>
            <a id="pestmes_a_href_0" v-show="equipment != 'pc'" :href="$rootUrl + '/mobile/service_detail/' + product.product_id">
              {{item.product_name}}
            </a>
          </h1>
          <div class="intro-row">
            <div class="pest-intro-subtitle blue-7 f11 mb6">简介</div>
            <div class="lh26 f14 mb20">
              <!--温暖潮湿、食物丰富和多缝隙，是蟑螂孳生的基本条件。我们的生活工作空间，大都具备这些条件，不管是厨房还是卫生间，甚至是散落了食物碎屑的沙发都有可能成为蟑螂的入侵点。此外，蟑螂容易通过各种途径被携带进入室内，最为常见的就是快递纸盒，所以蟑螂就成了侵害千家万户的卫生害虫。-->
              {{item.mes}}
            </div>
          </div>
          <div class="intro-row">
            <div class="pest-intro-subtitle blue-7 f11 mb10">常见种类</div>
            <div class="pest-category-wrapper">
              <div :data-fuget="titem.fuget_id" class="pest-type flex-row " :class="titem.type? '': 'not-clickable'" v-for="(titem, tindex) in item.pest_type" :key="tindex" :id="'pestmes_div_showPestDetail_'+tindex"  @click="titem.type?showPestDetail(tindex, titem): ''">
                <div class="pest-type-title">{{titem.name}}</div>
                <img src="@/assets/img/resources/arrow-r-light.svg" class="icon">
              </div>
            </div>
          </div>
          <div id="pestmes_div_showMore_handler" class="drawer-handler" @click="showMore(index)">
            <div class="stretched-out"></div>
            <img src="@/assets/img/resources/icon-drawer.svg" class="icon-drawer"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import '@/styles/pest_wiki/global2.less';
  import '@/styles/pest_wiki/pest_wiki_detail.less';
  import utils from '@/controller/utils'
  export default {
    name: "pest_mes",
    props: ['product', 'contains', 'equipment'],
    data () {
      return {
        status:false,
        list: [
          {
            id: 2,
            img: '1_zhangl_pc.jpg',
            product_name: '蟑螂',
            mes: '温暖潮湿、食物丰富和多缝隙，是蟑螂孳生的基本条件。我们的生活工作空间，大都具备这些条件，不管是厨房还是卫生间，甚至是散落了食物碎屑的沙发都有可能成为蟑螂的入侵点。此外，蟑螂容易通过各种途径被携带进入室内，最为常见的就是快递纸盒，所以蟑螂就成了侵害千家万户的卫生害虫。',
            pest_type: [
              {name: '德国小蠊',fuget_id: '297', type: true},
              {name: '美洲大蠊',fuget_id: '302', type: true},
              {name: '黑胸大蠊',fuget_id: '299', type: true}
            ]
          },
          {
            id: 3,
            img: '2_baiyi_pc.jpg',
            product_name: '白蚁',
            mes: '作为最古老的社会性昆虫之一，白蚁常被视为破坏力最大的害虫。白蚁群体中有明确的“社会分工”：蚁后、蚁王负责繁衍后代（原始蚁后能活10-30年）；工蚁负责建巢、修路、汲水、采食、搬运、喂食和清洁等工作，数量最多；兵蚁保卫蚁巢，占整个蚁群1%-2%，无取食能力，需工蚁喂食',
            pest_type: [
              {name: '台湾乳白蚁', fuget_id: '320', type: true},
              {name: '黄胸散白蚁', fuget_id: '312', type: true},
              {name: '黑胸散白蚁', fuget_id: '311', type: true},
            ]
          },
          {
            id: 4,
            img: '3_mouse_pc.jpg',
            product_name: '老鼠',
            mes: '老鼠是现存最原始的哺乳动物之一，生命力旺盛、数量繁多且迅速。凭借超强的适应能力和智商，老鼠几乎适应了各地的环境，遍布全球，但这也给人类带来了源源不断的困扰和危害。中世纪的黑死病便是它的杰作。根据场所不同，可将鼠类分为家栖鼠类和野栖鼠类。家栖鼠类是我们主要的防治对象。',
            pest_type: [
              {name: '小家鼠', fuget_id: '334', type: true},
              {name: '褐家鼠', fuget_id: '325', type: true},
              {name: '黄胸鼠', fuget_id: '326', type: true},
            ]
          },
          {
            id: 5,
            img: '4_mayi_pc.jpg',
            product_name: '蚂蚁',
            mes: '全球有超过10000种蚂蚁，中国已确定的蚂蚁种类有600多种。依据蚂蚁的形态、行为和社会分工，分成4个基本品级：雌蚁、雄蚁、工蚁和兵蚁。各品级间分工明确，各司其职。作为一种社会性昆虫，蚂蚁如果入侵室内，也会对人们的工作、生活带来不小的危害和滋扰。',
            pest_type: [
              {name: '小黄家蚁', fuget_id: '350', type: true},
              {name: '路舍蚁', fuget_id: '344', type: true},
              {name: '大头蚁', fuget_id: '338', type: true},
              {name: '臭蚁', fuget_id: '337', type: true},
              {name: '红火蚁', fuget_id: '341', type: true},
              {name: '弓背蚁', fuget_id: '340', type: true},
            ]
          },
          {
            id: 6,
            img: '5_tiao_pc.jpg',
            product_name: '跳蚤',
            mes: '跳蚤为属于完全变态类昆虫。成虫长为1-8毫米，棕色，是小型、无翅、善跳跃的寄生性昆虫，通常寄生在哺乳类动物和鸟类身上。口器锐利，用于吸吮。后腿发达、粗壮；具刺吸式口器，雌雄均吸血；幼虫无足呈圆柱形，具咀嚼式口器，以成虫血便或有机物质为食。',
            pest_type: [
              {name: '猫蚤', fuget_id: '357', type: false},
              {name: '狗蚤', fuget_id: '354', type: false},
              {name: '鼠蚤', fuget_id: '363', type: false},
              {name: '人蚤', fuget_id: '361', type: false},
            ]
          },
          {
            id: 7,
            img: '6_cang_pc.jpg',
            product_name: '苍蝇',
            mes: '成年家蝇的平均寿命是30天，它们完整的生命周期有四个阶段，包括卵、幼虫、蛹以及成蝇，其幼虫被称为蛆。苍蝇多以腐败有机物为食，因此常见于卫生较差的环境。苍蝇具有舐吮式口器，会污染食物，传播疾病，因此常被视为一种卫生害虫。',
            pest_type: [
              {name: '家蝇', fuget_id: '368', type: true},
              {name: '市蝇', fuget_id: '377', type: true},
              {name: '丽蝇', fuget_id: '371', type: true},
              {name: '麻蝇', fuget_id: '372', type: true},
            ]
          },
          {
            id: 8,
            img: '7_wenzi_pc.jpg',
            product_name: '蚊子',
            mes: '蚊子是一种具有刺吸式口器的细小昆虫。绝大多数蚊子中，雄蚊以植物汁液为食，雌蚊则外寄生于其他生物表面，使用刺吸式口器刺穿宿主的皮肤以吸取血液。吸食过程中，蚊子的唾液会使宿主出现皮疹等症状，且是许多种疾病的传播媒介，每年因蚊虫造成的死亡人数在所有动物中最多，被称为世界上最危险的动物。',
            pest_type: [
              {name: '伊蚊' ,fuget_id: '409' ,type: true},
              {name: '按蚊' ,fuget_id: '399' ,type: true},
              {name: '库蚊' ,fuget_id: '401' ,type: true},
            ]
          },
          {
            id: 9,
            img: '8_chouchong_pc.jpg',
            product_name: '臭虫',
            mes: '成年的臭虫是一种褐红色的昆虫，扁平带椭圆形，少数臭虫有翅膀且会飞。臭虫的身上长有微细的毛，看起来像是有条纹。成虫普遍长4到5毫米，宽1.5到3毫米。臭虫以人类血液为食，它的首选栖息地是房子的床板，尤其是病床或其他公共场所的床，可以在一个相当广泛的温度和大气成分比例环境里存活。',
            pest_type: [
              {name: '温带臭虫', fuget_id: '423', type: false},
              {name: '热带臭虫', fuget_id: '416', type: false},
              {name: '疏毛臭虫', fuget_id: '421', type: false},
              {name: '燕臭虫', fuget_id: '424', type: false},
              {name: '燕臭虫', fuget_id: '413', type: false},
            ]
          },
          {
            id: 10,
            img: '9_jiman_pc.jpg',
            product_name: '寄螨',
            mes: '寄螨总目下包含了所有蜱螨类生物，大多数是寄生生物。螨总目中约有5000种属于革螨亚目，都是掠食性生物，通常隐居在软土、垃圾堆、腐木、鸟巢、家居尘埃中。其中革螨、蜱对人类生活危害较大，它们会对人发起攻击，通过叮咬、吸血等方式致使人过敏、皮炎甚至严重的疾病，对人们的健康构成威胁。',
            pest_type: [
              {name: '蜱', fuget_id: '431', type: true},
              {name: '革螨', fuget_id: '428', type: true}
            ]
          },
          {
            id: 11,
            img: '10_yiyu_pc.jpg',
            product_name: '衣鱼',
            mes: '衣鱼是一种无翅昆虫，常躲藏在黑暗处，昼伏夜出。体长4~20mm，背腹扁平，常多鳞片和毛。触角长丝状，复眼分离，口器咀嚼式，腹部11节。若虫外形与成虫相似，只是形体较小，身体呈白色至棕灰色，衣鱼尾部有三根长毛（缨尾），这是一个较为显著的特征。',
            pest_type: [
              {name: '毛衣鱼', fuget_id: '444', type: false},
              {name: '台湾衣鱼', fuget_id: '448', type: false},
              {name: '家衣鱼', fuget_id: '441', type: false},
            ]
          },
          {
            id: 12,
            img: '11_chufangfeic_pc.jpg',
            product_name: '厨卫飞虫',
            mes: '厨房和卫生间，是飞虫滋生的高发区。大多数家庭都曾经在厨卫区域与这种“小黑飞”不期而遇。这些飞虫基本不咬人，但由于其滋生地通常为藏污纳垢之处，如湿拖把、地漏、下水管道，容易接触和携带环境中的细菌，给人带来滋扰危害。',
            pest_type: [
              {name: '蛾蚋', fuget_id: '453', type: true},
              {name: '果蝇', fuget_id: '455', type: true},
              {name: '蚤蝇', fuget_id: '463', type: true},
              {name: '蕈蚊', fuget_id: '452', type: true},
            ]
          },
          {
            id: 13,
            img: '12_zhiwuhaic_pc.jpg',
            product_name: '织物害虫',
            mes: '有时候好端端的一件衣服或是地毯，莫名其妙多出很多破洞，很有可能是因为遭到了织物害虫的入侵。织物/地毯害虫以天然蛋白质（角蛋白）为食，任何动物来源的织物材料都可能成为它们破坏的对象，包括羊毛、棉花、丝绸、皮革和羽毛等。有些也会危害粮食谷物。',
            pest_type: [
              {name: '衣蛾' ,fuget_id: '478', type: true},
              {name: '小圆皮蠹' ,fuget_id: '477', type: true},
              {name: '黑皮蠹' ,fuget_id: '468', type: true},
              {name: '花斑皮蠹' ,fuget_id: '469', type: true},
            ]
          },
          {
            id: 14,
            img: '13_zhumu_pc.jpg',
            product_name: '蛀木害虫',
            mes: '装修时花尽心思搭配的木制家具，却没想因为某些害虫入侵导致内部千疮百孔、表面出现孔洞？或是在门窗框、踢脚线、地板等处发现莫名的粉末？这些很可能是蛀木害虫的杰作。虽不及白蚁臭名昭著，但这些蛀木害虫，尤其是其幼虫，同样会对建筑木材、木制家具等造成不小的破坏。',
            pest_type: [
              {name: '小蠹', fuget_id: '494', type: true},
              {name: '粉蠹', fuget_id: '482', type: true},
              {name: '窃蠹', fuget_id: '487', type: true},
              {name: '天牛', fuget_id: '492', type: true},
              {name: '木蜂', fuget_id: '486', type: true},
              {name: '竹蠹', fuget_id: '495', type: true},
              {name: '黑尾拟天牛', fuget_id: '483', type: true},
            ]
          },
          {
            id: 15,
            img: '14_dingzhi_pc.jpg',
            product_name: '叮蛰害虫',
            mes: '某些昆虫（基本为细腰亚目），如寄生蜂、黄蜂。此外，叮蛰害虫多为社会性昆虫，由蜂王、雄蜂、工蜂等组成。通常在感到自身或蜂群受到威胁时，它们会以叮蛰进行防卫。叮蛰害虫中，只有雌性才会叮蛰，有些叮蛰害虫毒性十分强，除了会引发过敏，严重的还会导致眩晕、呕吐甚至休克。',
            pest_type: [
              {name: '寄生蜂', fuget_id: '500', type: true},
              {name: '蜜蜂', fuget_id: '503', type: true},
              {name: '黄蜂', fuget_id: '499', type: true},
            ]
          },
          {
            id: 16,
            img: '15_chaoshi_pc.jpg',
            product_name: '潮湿害虫',
            mes: '我国南方大多地处亚热带区域，常年温湿度较高，越往南城市如广州、深圳更甚，江南地区则有漫长的梅雨季节缠扰。很多家庭楼层较低或家居没做好防潮处理的，则很容易出现墙体发霉、微菌滋生、虫害繁殖的情况。在这些区域常出现的害虫被统称为潮湿害虫。它们往往成群出现，以霉菌、真菌为食。',
            pest_type: [
              {name: '书虱', fuget_id: '520', type: true},
              {name: '跳虫', fuget_id: '521', type: true},
              {name: '薪甲', fuget_id: '523', type: true},
              {name: '拟裸蛛甲', fuget_id: '515', type: true},
              {name: '米扁虫', fuget_id: '514', type: true},
              {name: '日本伪瓢虫', fuget_id: '518', type: true},
            ]
          },
          {
            id: 17,
            img: '16_cangchu_pc-1.jpg',
            product_name: '仓储害虫',
            mes: '仓储害虫分为两个主要的昆虫类别：鞘翅类（甲虫）和鳞翅类（蛾），常见于谷物、麦子、脱水的水果和种子中，无论是家庭还是商用场所如食品工厂、仓库、餐厅等都可以见到它们的身影。仓储害虫破坏性较强，会对粮食储物造成污染和危害，对人们的健康造成威胁。粮食仓储害虫有300多种，我国有50余种。',
            pest_type: [
              {name: '锯谷盗', fuget_id: '530', type: true},
              {name: '豆象', fuget_id: '527', type: true},
              {name: '米象', fuget_id: '533', type: true},
              {name: '烟草甲', fuget_id: '540', type: true},
              {name: '药材甲', fuget_id: '541', type: true},
              {name: '赤拟谷盗', fuget_id: '526', type: true},
              {name: '杂拟谷盗', fuget_id: '543', type: true},
              {name: '锈赤扁谷盗', fuget_id: '539', type: true},
              {name: '印度谷螟', fuget_id: '542', type: true},
              {name: '粉斑螟', fuget_id: '529', type: true},
            ]
          },
          {
            id: 18,
            img: '17_duozu_pc.jpg',
            product_name: '多足害虫',
            mes: '节肢动物门里有一些虫外形略微恶心恐怖，譬如多足害虫，它们遍布等足目、倍足纲、唇足纲，大都活动敏捷，多以腐殖质或小昆虫为食，最常见于室外草地、土壤中，喜欢阴暗潮湿的环境，但有时也会因湿度、食物、植物携带等原因进入室内，造成危害。它们通常不会咬人，但有时因感受到威胁而攻击人，有些会释放毒液。',
            pest_type: [
              {name: '潮虫', fuget_id: '546', type: true},
              {name: '鼠妇', fuget_id: '555', type: true},
              {name: '蜈蚣', fuget_id: '557', type: true},
              {name: '蚰蜒', fuget_id: '558', type: true},
              {name: '马陆', fuget_id: '550', type: true},
            ]
          },
          {
            id: 20,
            img: '18_ouranr_pc-1.jpg',
            product_name: '花园害虫',
            mes: '草坪、花园、绿化当中是各类甲虫、爬虫、飞虫等害虫聚集的热点区域。住在低层的住户以及老洋房、别墅等用户由于毗邻外围绿化，遇到此类害虫的几率比较大，偶尔它们也会因为觅食或在室内寻到合适的栖息地，或因趋光性被灯光吸引入侵室内，我们将其统称为花园害虫或偶然入侵害虫。',
            pest_type: [
              {name: '蜘蛛', fuget_id: '578', type: true},
              {name: '蛞蝓', fuget_id: '563', type: true},
              {name: '蜗牛', fuget_id: '574', type: true},
              {name: '步甲', fuget_id: '561', type: true},
              {name: '蟋蟀', fuget_id: '575', type: true},
              {name: '鳃金龟', fuget_id: '570', type: true},
              {name: '土蝽', fuget_id: '572', type: true},
              {name: '猎蝽', fuget_id: '566', type: true},
              {name: '麻皮蝽', fuget_id: '567', type: true},
              {name: '叶螨', fuget_id: '576', type: true},
              {name: '隐翅虫', fuget_id: '577', type: true},
            ]
          }
        ]
      }
    },
    methods: {
      showPestDetail(num, item) {
        utils.ga.cta(item.name)
        this.$parent.showPestDetail(num)
      },
      showMore(index) {
        this.$parent.showMore();
        var data = this.list[index];
        let text = 'Wiki-' + data.mes;
        utils.ga.openText(text, this.status == true?'Close':'Open');
        this.status = !this.status;
      
      }
    }
  }
</script>

<style lang="less" scoped>
  a {
    color: #337ab7;
  }
</style>



// WEBPACK FOOTER //
// src/components/pest_mes.vue